import React, { useEffect, useRef, useState } from 'react';
import { Flame, Wheat, Utensils } from 'lucide-react';
import './Products.css';

const DOGO_IMG = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/wwjwb7j5_57A85D17-DF9A-4013-BCA9-0AD849E81131.jpeg';
const INTERIOR_IMG = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/gpuksp5b_IMG_0064.jpeg';
const STOREFRONT_IMG = 'https://customer-assets.emergentagent.com/job_9363419a-0d44-45af-86ed-64a5aaaae19b/artifacts/80u1nwvu_IMG_0073.jpeg';

const products = [
  {
    title: 'Dogo Clásico',
    desc: 'Pan artesanal con ajonjolí, salchicha premium de pavo, tomate, cebolla y crema',
    price: '$50',
    img: DOGO_IMG,
    tag: 'Favorito',
  },
  {
    title: 'Nuestro Local',
    desc: 'Un espacio acogedor con madera natural, plantas vivas y la mejor vibra de Tapalpa',
    img: INTERIOR_IMG,
    tag: 'Experiencia',
  },
  {
    title: 'Andador Obregón #110',
    desc: 'Frente a los Jaimes, en el corazón del centro de Tapalpa. No puedes perdernos.',
    img: STOREFRONT_IMG,
    tag: 'Encuéntranos',
  },
];

const features = [
  { icon: Wheat, label: 'Pan artesanal', sub: 'con ajonjolí' },
  { icon: Utensils, label: 'Salchicha premium', sub: 'de pavo' },
  { icon: Flame, label: 'Air Fryer', sub: 'papas y aros' },
];

export const Products = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.1 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section className="products" id="productos" ref={ref} data-testid="products-section">
      <div className="products-glow" />
      <div className="products-container">
        <div className={`products-header ${visible ? 'vis' : ''}`}>
          <div className="section-fire-line" />
          <span className="products-eyebrow">Nuestro Menú</span>
          <h2 className="products-title">Dogos Que Enamoran</h2>
          <p className="products-subtitle">Cada dogo es preparado con ingredientes seleccionados y mucho amor</p>
        </div>

        <div className={`products-features ${visible ? 'vis' : ''}`} data-testid="products-features">
          {features.map((f, i) => (
            <div className="products-feature" key={i} style={{ animationDelay: `${0.2 + i * 0.15}s` }}>
              <div className="products-feature-icon"><f.icon size={22} strokeWidth={1.5} /></div>
              <strong>{f.label}</strong>
              <span>{f.sub}</span>
            </div>
          ))}
        </div>

        <div className={`products-grid ${visible ? 'vis' : ''}`} data-testid="products-grid">
          {products.map((p, i) => (
            <div className="products-card" key={i} style={{ animationDelay: `${0.3 + i * 0.2}s` }} data-testid={`product-card-${i}`}>
              <div className="products-card-img">
                <img src={p.img} alt={p.title} loading="lazy" />
                <span className="products-card-tag">{p.tag}</span>
                {p.price && <span className="products-card-price">{p.price}</span>}
              </div>
              <div className="products-card-body">
                <h3>{p.title}</h3>
                <p>{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Products;
